import Vue from "vue";

export const statesService = {
  list,
  getById,
  create,
  update
};

function list(params) {
  return Vue.axios.get("v1/states", { params });
}

function getById(id) {
  return Vue.axios.get(`v1/states/${id}`);
}

function create(payload) {
  return Vue.axios.post("v1/states", payload);
}

function update(payload) {
  return Vue.axios.patch(`v1/states/${payload.id}`, payload);
}
